import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
  Autocomplete,
  Modal,
} from "@mui/material";
import commonapihandler from "../../common/commonapihandler";
import { getCityName, getHubName, getSystemUserList } from "../../api/api";
import formatDateAndTime from "../../common/formatDateAndTime";
import { BlinkBlur } from "react-loading-indicators";
import toast from "react-hot-toast";
import moment from "moment";
import { camelToNormal } from "../../common/caseconversion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Fieldscommonmodal from "../../common/Fieldscommonmodal";
import fileUpload from "../../common/fileupload";
import Viewblockdetails from "./Viewblockdetails";
import Textfields from "../../common/Textfields";
import { Plus, Upload, X } from "lucide-react";
import Uploadmultplefile from "../../common/Uploadmultplefile";

const imagestyle = {
  position: "fixed",
  inset: 0,
  width: "100vw",
  height: "100vh",
  bgcolor: "#ffffff",
  boxShadow: 24,
  p: 3,
  overflow: "hidden",
};

function createData(
  id,
  name,
  registrationno,
  startdate,
  enddate,
  totalNoOfDay,
  blocktype,
  status,
  blockedby,
  createdon,
  action,
  raw,
) {
  return {
    id,
    name,
    registrationno,
    startdate,
    enddate,
    totalNoOfDay,
    blocktype,
    status,
    blockedby,
    createdon,
    action,
    raw,
  };
}

const Blockedvehicles = ({ setActiveItem }) => {
  const querydisplay = new URLSearchParams(window.location.search).get(
    "display",
  );
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const isMobile = useMediaQuery("(max-width:768px)");
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);

  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [dateFitlerBy, setDateFilterBy] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [openTab, setOpenTab] = useState(false);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  const [allBookings, setAllBookings] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [vehicleListings, setVehicleListings] = useState([]);
  const [vehicleId, setVehicleId] = useState(null);
  const [selectedSearchButton, setSelectedSearchButton] = useState("");
  const [searchValues, setSearchValues] = useState(null);
  const [bookingstatus, setBookingStatus] = useState(null);
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [form, setForm] = useState({});
  const [error, setError] = useState("");
  const catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role
    ?.inverted?.franchiseAdmin;
  const catalogRActions = JSON.parse(localStorage.getItem("catalogValues"))
    ?.action?.inverted?.viewMyCityBookings;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const vehicleBlockType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBlockType;
  const blockRequestTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.blockRequestTypes;
  const [vehicleIssuesData, setVehicleIssuesData] = useState(null);
  const [vehicleData, setVehicleData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [blockedVehicleList, setBlockedVehiclesList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [blockedVehciles, setBlockedVehicles] = useState([]);

  const getaffectedBlockings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/blockedvehicles/blocklistbyvehicle?vehicleId=${selectedRow?.vehicleId}&startDate=${
          form?.startdate + "T" + form?.starttime
        }&endDate=${form?.enddate + "T" + form?.endtime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBlockedVehicles(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  const vehicleDetailsUnblockFields = [
    {
      label: "Start Date",
      value: "startdate",
      type: "date",
      disabled: false,
    },
    {
      label: "End Date",
      value: "enddate",
      type: "date",
      disabled: false,
    },
    {
      label: "Vehicle",
      value: "vehicle",
      type: "text",
      disabled: false,
    },
    {
      label: "Starting Odometer",
      value: "startingOdometer",
      type: "number",
      disabled: false,
    },
    {
      label: "Current Odometer",
      value: "currentOdometer",
      type: "number",
      disabled: false,
    },
    {
      label: "Comment",
      value: "comment",
      type: "text",
      disabled: false,
    },
  ];

  const vehicleDetailsEditBlockFields = [
    {
      label: "Start Date",
      value: "startdate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Start Time",
      value: "starttime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Date",
      value: "enddate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Time",
      value: "endtime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vehicle",
      value: "vehicle",
      type: "text",
      disabled: true,
      subCategory: null,
    },
    {
      label: "Current Odometer",
      value: "currentOdometer",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Requested By",
      value: "requestedby",
      type: "dropdown",
      disabled: false,
      subCategory:
        blockRequestTypes &&
        Object.entries(blockRequestTypes).map(([key, value]) => ({
          value: value,
          item: key,
        })),
    },
    {
      label: "Block Type",
      value: "blocktype",
      type: "dropdown",
      disabled: false,
      subCategory:
        vehicleBlockType &&
        Object.entries(vehicleBlockType).map(([key, value]) => ({
          value: value,
          item: key,
        })),
    },
    {
      label: "Vehicle Issues",
      value: "vehicleissues",
      type: "dropdown",
      disabled: false,
      subCategory: Array.isArray(vehicleIssuesData)
        ? vehicleIssuesData.map((item) => {
            return {
              value: item?.code,
              item: item?.id,
            };
          })
        : [],
    },
    {
      label: "Booking Id",
      value: "bookingid",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Comment",
      value: "comment",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Odometer Image",
      value: "odometerimage",
      type: "file",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Other Attachments",
      value: "otherattachments",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  const getVechileListings = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=500&offset=0&hubId=${id}`,
        {
          method: "GET",
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleFilterListings(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getVehicleData = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicles/${id}`, {
        method: "GET",
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleData(data?.entityValue);
        await getVehicleIssuesDataAPI(selectedRow?.vehicleId);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    if (hub) {
      getVechileListings(hub);
    }
  }, [hub]);

  const handleModalClose = () => {
    setSelectedRow(null);
    setForm({
      currentOdometer: null,
    });
    setActiveTabIndex(0);
    setOpenModal(false);
    setBlockedVehicles([]);
    setError("");
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const columns = [
    { id: "id", label: "Id", minWidth: 100, align: "start" },
    { id: "name", label: "Name", minWidth: 200, align: "start" },
    {
      id: "registrationno",
      label: "Registration No",
      minWidth: 150,
      align: "start",
    },
    { id: "startdate", label: "Blocked From", minWidth: 200, align: "start" },
    { id: "enddate", label: "Blocked To", minWidth: 200, align: "start" },
    {
      id: "totalNoOfDay",
      label: "Total Blocked days",
      minWidth: 200,
      align: "start",
    },
    { id: "blocktype", label: "Block Type", minWidth: 150, align: "start" },
    { id: "status", label: "Status", minWidth: 150, align: "start" },
    { id: "blockedby", label: "Blocked By", minWidth: 150, align: "start" },
    { id: "createdon", label: "Created On", minWidth: 200, align: "start" },
    { id: "view", label: "View", minWidth: 90, align: "start" },
    { id: "action", label: "Action", minWidth: 90, align: "start" },
    { id: "edit", label: "Edit Details", minWidth: 150, align: "start" },
  ];

  const rows = Array.isArray(allBookings)
    ? allBookings
        .filter((item) => item) // removes null/undefined items
        .map((item) =>
          createData(
            item?.id || "",
            camelToNormal(item?.name || ""),
            item?.licensePlate || "/",
            item?.startDate ? formatDateAndTime(item.startDate) : "-",
            item?.endDate ? formatDateAndTime(item.endDate) : "-",
            item?.totalNoOfDay || 0,
            vehicleBlockType?.[item?.blockType] || "-",
            item?.isUnblocked ? "Unblocked" : "Blocked",
            item?.blockedBy || "-",
            item?.createdAt ? formatDateAndTime(item.createdAt) : "-",
            "View",
            item,
          ),
        )
    : [];

  useEffect(() => {
    if (querydisplay) {
      setOpenTab(true);
    }
  }, [querydisplay]);

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getCityNames();
    getAllVehicles();
    getAllHubsList();
  }, []);

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100")
        setGetAllHubsListData(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleCityChange = (event) => {
    setPage(0);
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  const handleHubChange = (event) => {
    setPage(0);
    setHub(event.target.value);
  };

  useEffect(() => {
    if (hub) {
      getAllVehicles();
    }
  }, [hub]);

  const getAllVehicles = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    setLoading(true);
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    if (selectedVehicle) {
      let split = selectedVehicle?.licensePlate?.split(" - ");
      let licensePlate = split ? split[0] : selectedVehicle?.licensePlate;
      query += `&licensePlate=${licensePlate}`;
    }

    if (hub) {
      query += `&hubId=${hub}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/blockedvehicles?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllBookings(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const updateBlockedVehicleDetails = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/blockedvehicles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: selectedRow?.id,
          vehicleId: selectedRow?.vehicleId,
          initialOdometer: Number(form?.startingOdometer),
          finalOdometer: Number(form?.currentOdometer),
          unblockComment: form?.comment,
          isUnblocked: true,
          unblockedBy: profile?.id,
          unblockDate: moment().toISOString(),
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          currentOdometer: null,
        });
        setOpenModal(false);
        toast.success("Vehicle Changes Updated successfully");
        getAllVehicles();
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);

    getAllVehicles(0, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    getAllVehicles(newPage, rowsPerPage);
  };

  const handleEditClick = (row) => {
    const raw = row.raw;
    setSelectedRow(raw);
    setForm({
      //   currentOdometer: selectedRow?.currentOdometer || null,
      startdate: row.startdate
        ? new Date(row.startdate).toISOString().split("T")[0]
        : null,
      enddate: row.enddate
        ? new Date(row.enddate).toISOString().split("T")[0]
        : null,
      vehicle: raw?.name || null,
      startingOdometer: raw?.initialOdometer || null,
    });
    setOpenModal(true);
  };

  const handleUpdateDetailsClick = async (row) => {
    const raw = row.raw;
    setSelectedRow(raw);
    setActiveTabIndex(1);

    setForm({
      //   currentOdometer: selectedRow?.currentOdometer || null,
      startdate: row.startdate
        ? new Date(row.startdate).toISOString().split("T")[0]
        : null,
      enddate: row.enddate
        ? new Date(row.enddate).toISOString().split("T")[0]
        : null,
      starttime: row.startdate
        ? new Date(row.startdate).toISOString().split("T")[1]?.slice(0, 5)
        : null,
      endtime: row.enddate
        ? new Date(row.enddate).toISOString().split("T")[1]?.slice(0, 5)
        : null,
      vehicle: raw?.name || null,
      currentOdometer: raw?.initialOdometer || null,
    });
  };

  useEffect(() => {
    if (form?.startdate && form?.starttime && form?.enddate && form?.endtime) {
      getaffectedBlockings();
    }
  }, [form?.enddate, form?.endtime]);

  const handleViewClick = (row) => {
    const raw = row.raw;
    setSelectedRow(raw);
    setActiveTabIndex(2);
  };

  useEffect(() => {
    if (selectedRow?.id) {
      getVehicleData(selectedRow?.id);
    }
  }, [selectedRow]);

  const handleChange = async (field, value) => {
    try {
      if (field === "odometerimage" || field === "otherattachments") {
        const res = await Uploadmultplefile(value, "vehicles", "vehicle");
        const filterImages = res?.uploaded?.map((img) => img?.url);
        setUploadedImages((prev) => {
          if (!prev || prev.length === 0) {
            return filterImages; // first upload
          }
          return [...prev, ...filterImages]; // append
        });
        setForm((prev) => ({ ...prev, [field]: res?.uploaded || "" }));
      } else if (field === "carimage") {
        const res = await fileUpload(value[0], "vehicles", "vehicle");
        setUploadedImages([res]);
        setForm((prev) => ({ ...prev, [field]: [res] || "" }));
      } else {
        setForm((prev) => ({ ...prev, [field]: value }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleReset = () => {
    setCity("");
    setHub("");
    setSelectedVehicle(null);
    setBlockedVehiclesList([]);
    setPage(0);
    setDateFilterBy(null);
    setBookingStatus(null);
    getAllVehicles();
  };

  const getVehicleIssuesDataAPI = async (id) => {
    const apiDetails = await getSystemUserList(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setVehicleIssuesData(response?.entities?.rows);
    }
  };

  const UpdateVehicleDetails = async () => {
    if (!form?.startdate && !form?.starttime) {
      return toast?.error("Start date and time is not available", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.enddate && !form?.endtime) {
      return toast?.error("End date and time is not available", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.requestedby) {
      return toast?.error("Requested By is not available", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.blocktype) {
      return toast?.error("Block type is not available", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.odometerimage) {
      return toast?.error("Odometer image is not available", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.currentOdometer) {
      return toast?.error("Odometer is not available", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    try {
      const response = await fetch(`${apiUrl}/api/blockedvehicles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: selectedRow?.id,
          initialOdometer: form?.currentOdometer,
          comment: form?.comment,
          blockType: form?.blocktype,
          startDate: form?.startdate + "T" + form?.starttime,
          endDate: form?.enddate + "T" + form?.endtime,
          bookingCode: form?.bookingid || null,
          blockHistory: {
            blockId: selectedRow?.id,
            vehicleId: vehicleData?.id,
            comment: form?.comment,
          },
          odometerImages: JSON.stringify(form?.odometerimage),
          attachments: JSON.stringify(form?.otherattachments),
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          currentOdometer: null,
        });
        toast.success("Vehicle Blocked successfully.", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setActiveTabIndex(0);
        setUploadedImages(null);
        getAllVehicles();
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const handleGenerate = async () => {
    if (!form?.filtertype || !form?.startDate || !form?.endDate) {
      return toast.error("Fill Details to download report", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }

    try {
      const endpoint = `/api/reports/blocked-vehicles?datefilterType=${
        form.filtertype
      }&startDate=${form.startDate + "T00:00"}&endDate=${
        form.endDate + "T23:59"
      }`;

      if (!endpoint) {
        toast.error("Report endpoint not defined!");
        return;
      }

      const url = `${apiUrl}${endpoint}`;
      const response = await toast.promise(
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        {
          loading: "Generating report...",
          success: "Report generated successfully!",
          error: "Failed to generate report!",
        },
      );

      const data = await response.json();
      if (data?.statusCode === "0100" && data?.entities?.result === -1) {
        toast.error(data?.entities?.msg, {
          position: "top-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      } else {
        setOpen(false);
        setForm({});
        window.open(data.entities.Location, "_blank");
        toast.success("Report generated successfully", {
          position: "top-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
    } catch (error) {
      console.error("Error generating report:", error);
    }
  };

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 h-screen">
          <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Block Report Download</h3>
              <button
                onClick={() => {
                  setOpen(false);
                  setForm({});
                }}
              >
                <X className="text-slate-500 hover:text-red-500" />
              </button>
            </div>

            {/* Form */}
            <div className="space-y-4">
              {/* <select
                className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                value={form.city}
                onChange={(e) => {
                  handleChange("city", e.target.value);
                  getHubNames(e.target.value);
                }}
              >
                <option value="">Select City</option>
                {Object.entries(cities).map(([key, label]) => (
                  <option key={key} value={key}>
                    {label}
                  </option>
                ))}
              </select>

              <select
                className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                value={form.hub}
                onChange={(e) => handleChange("hub", e.target.value)}
              >
                <option value="">Select Hub</option>
                {hubs ? (
                  hubs.map((hub) => (
                    <option key={hub.id} value={hub.id}>
                      {hub.hubName}
                    </option>
                  ))
                ) : (
                  <option disabled>Select City first</option>
                )}
              </select> */}

              <select
                className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                value={form.filtertype}
                onChange={(e) => handleChange("filtertype", e.target.value)}
              >
                <option value="">Select Date Filter Type</option>
                <option value="createdAt">Created At</option>
                <option value="startDate">Blocked From</option>
                <option value="endDate">Blocked To</option>
              </select>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="startDate"
                    className="text-sm font-medium text-gray-700"
                  >
                    Start Date
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    name="startDate"
                    className="w-full border rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={form.startDate || ""}
                    onChange={(e) => handleChange("startDate", e.target.value)}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="endDate"
                    className="text-sm font-medium text-gray-700"
                  >
                    End Date
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    name="endDate"
                    className="w-full border rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={form.endDate || ""}
                    min={form.startDate} // 🔥 prevents earlier date selection
                    onChange={(e) => handleChange("endDate", e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => {
                  setOpen(false);
                  setForm({});
                }}
                className="px-4 py-2 border rounded-lg text-sm"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleGenerate();
                }}
                className="px-5 py-2 bg-teal-600 text-white rounded-lg text-sm hover:bg-teal-700"
              >
                Generate
              </button>
            </div>
          </div>
        </div>
      )}

      {openModal && (
        <>
          <Fieldscommonmodal
            open={openModal}
            onClose={handleModalClose}
            textfields={vehicleDetailsUnblockFields}
            UpdateVehicleDetails={updateBlockedVehicleDetails}
            form={form}
            handleChange={handleChange}
            setForm={setForm}
            selectedRow={selectedRow}
            error={error}
            vehicleStatus={() => {}}
            affectedBookings={() => {}}
          />
        </>
      )}

      {activeTabIndex === 0 ? (
        <>
          <div className="my-4 text-xl md:text-2xl px-2 font-bold flex justify-between items-center">
            <h1>View all Blocked Vehicles</h1>

            <div className="flex gap-3">
              <button
                onClick={() => {
                  getAllVehicles();
                }}
                class="p-5 rounded-full backdrop-blur-lg border border-green-500/20 bg-gradient-to-tr from-white/60 to-white/40 shadow-lg hover:shadow-2xl hover:shadow-green-500/30 hover:scale-110 hover:rotate-2 active:scale-95 active:rotate-0 transition-all duration-300 ease-out cursor-pointer hover:border-green-500/50 hover:bg-gradient-to-tr hover:from-green-500/10 hover:to-white/40 group relative overflow-hidden"
              >
                {" "}
                <div class="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"></div>{" "}
                <div class="relative z-10">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="100"
                    height="100"
                    viewBox="0 0 30 30"
                    className="w-6 h-6"
                  >
                    {" "}
                    <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>{" "}
                  </svg>{" "}
                </div>{" "}
              </button>

              <button
                title="Download Block Report"
                onClick={() => {
                  setOpen(true);
                }}
                className="p-5 rounded-full backdrop-blur-lg border border-blue-500/20 
      bg-gradient-to-tr from-white/60 to-white/40 shadow-lg 
      hover:shadow-2xl hover:shadow-blue-500/30 hover:scale-110 
      active:scale-95 transition-all duration-300 cursor-pointer 
      hover:border-blue-500/50 group relative overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400/20 to-transparent 
      -translate-x-full group-hover:translate-x-full transition-transform duration-700"
                />

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="w-6 h-6 relative z-10"
                  fill="currentColor"
                >
                  <path d="M12 16l4-5h-3V4h-2v7H8l4 5zm6 2H6v2h12v-2z" />
                </svg>
              </button>
            </div>
          </div>

          <Box p={isMobile ? 2 : 1}>
            <Box
              display="flex"
              flexDirection="column"
              p={2}
              borderRadius={2}
              boxShadow={3}
              mb={4}
              sx={{ backgroundColor: "white" }}
            >
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", md: "center" }}
                mb={3}
                gap={2}
              ></Box>

              <Box
                display="grid"
                gridTemplateColumns={{
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  lg: "repeat(5, 1fr)",
                }}
                gap={2}
                mb={3}
              >
                <h1 className="mt-2">Filter By :</h1>

                <FormControl fullWidth size="small">
                  <InputLabel id="city-select-label">City</InputLabel>
                  <Select
                    labelId="city-select-label"
                    id="city-select"
                    value={city}
                    onChange={handleCityChange}
                  >
                    {cities &&
                      Object.entries(cities).map(([key, value]) => (
                        <MenuItem key={key} value={key}>
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth size="small">
                  <InputLabel id="hub-select-label">Hub</InputLabel>
                  <Select
                    labelId="hub-select-label"
                    id="hub-select"
                    value={hub}
                    onChange={handleHubChange}
                  >
                    {
                      // hubs?.length ? (
                      getAllHubsListData &&
                        getAllHubsListData.map((item, index) => (
                          <MenuItem key={index} value={item?.id}>
                            {item?.hubName}
                          </MenuItem>
                        ))
                      // ) : (
                      //   <MenuItem value="">
                      //     <em>Select City First</em>
                      //   </MenuItem>
                      // )
                    }
                  </Select>
                </FormControl>

                <Autocomplete
                  fullWidth
                  freeSolo
                  options={vehicleFilterListings || []}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") return option;

                    const licensePlate = option?.licensePlate || "";
                    const name = option?.name || "";
                    const cityText = option?.cityText || "";
                    return `${licensePlate} - ${name} - ${cityText}`.trim();
                  }}
                  filterOptions={(options, { inputValue }) => {
                    return (options || []).filter((option) =>
                      (option?.licensePlate || "")
                        .toLowerCase()
                        .includes(inputValue.toLowerCase()),
                    );
                  }}
                  onChange={(event, newValue) => {
                    if (newValue && typeof newValue !== "string") {
                      setSelectedVehicle(newValue); // keep only selected vehicle
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Vehicle"
                      InputLabelProps={{ shrink: true }}
                      autoComplete="off"
                    />
                  )}
                />

                <Box display="flex" gap={2} alignItems="center">
                  <button
                    onClick={() => {
                      setPage(0);
                      getAllVehicles();
                    }}
                    className="w-12 h-12 rounded-full bg-violet-500 group shadow-xl flex items-center justify-center relative overflow-hidden"
                  >
                    <svg
                      className="w-6 h-6 text-gray-800 relative z-10 dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                      />
                    </svg>

                    <div className="w-full h-full rotate-45 absolute left-[32%] top-[32%] bg-green-500 group-hover:-left-[100%] group-hover:-top-[100%] duration-1000"></div>
                    <div className="w-full h-full -rotate-45 absolute -left-[32%] -top-[32%] group-hover:left-[100%] group-hover:top-[100%] bg-green-500 duration-1000"></div>
                  </button>

                  <button
                    onClick={() => {
                      handleReset();
                    }}
                    class="cursor-pointer transition-all bg-blue-500 text-white px-4 py-2 rounded-lg
border-blue-600
border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px]
active:border-b-[2px] active:brightness-90 active:translate-y-[2px]"
                  >
                    Reset
                  </button>
                </Box>
              </Box>
            </Box>

            <Paper
              sx={{
                // width: "80%",
                boxShadow: 6,
                borderRadius: 2,
                mt: 4,
              }}
            >
              <TableContainer
                sx={{
                  // maxHeight: 500,
                  overflowX: "scroll", // ✅ horizontal scroll only if needed
                }}
              >
                <Table stickyHeader aria-label="bookings table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          sx={{
                            backgroundColor: "#f8f7f6ff",
                            fontWeight: 300,
                          }}
                          key={column.id}
                          align={column.align || "left"}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <div className="flex flex-row gap-40 items-center h-40 justify-center">
                            <BlinkBlur
                              color={[
                                "#cd8032",
                                "#32cd32",
                                "#327fcd",
                                "#cd32cd",
                              ]}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : rows.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <h1 className="mt-10 text-lg font-bold">
                            No Data Found
                          </h1>
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows.map((row, idx) => (
                        <TableRow hover key={idx}>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                sx={{
                                  cursor: "pointer",
                                }}
                                //   onClick={() => handleEditClick(row)}
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "action" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color={
                                      row.raw?.isUnblocked
                                        ? "success"
                                        : "warning"
                                    }
                                    disabled={row.raw?.isUnblocked}
                                    onClick={() => handleEditClick(row)}
                                  >
                                    {row.raw?.isUnblocked
                                      ? "Unblocked"
                                      : "Unblock"}
                                  </Button>
                                ) : column.id === "view" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleViewClick(row)}
                                  >
                                    View
                                  </Button>
                                ) : column.id === "edit" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={row.raw?.isUnblocked}
                                    color="success"
                                    onClick={() =>
                                      handleUpdateDetailsClick(row)
                                    }
                                  >
                                    Edit Details
                                  </Button>
                                ) : column?.id === "vehicleid" ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <span className="w-44 truncate">
                                      {value || "-"}
                                    </span>
                                    {value && (
                                      <>
                                        {" "}
                                        <ContentCopyIcon
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            navigator.clipboard.writeText(
                                              value,
                                            );
                                            setCopied(true);
                                            setTimeout(
                                              () => setCopied(false),
                                              1500,
                                            );
                                          }}
                                          sx={{
                                            fontSize: 20,
                                            cursor: "pointer",
                                            color:
                                              copied === value
                                                ? "green"
                                                : "grey",
                                            transition: "color 0.2s",
                                          }}
                                        />
                                      </>
                                    )}
                                  </Box>
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value || "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[20, 30, 40]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                  },
                }}
              />
            </Paper>
          </Box>
        </>
      ) : activeTabIndex === 1 ? (
        <Textfields
          open={openModal}
          setActiveTab={setActiveTabIndex}
          textfields={vehicleDetailsEditBlockFields}
          UpdateVehicleDetails={UpdateVehicleDetails}
          form={form}
          handleChange={handleChange}
          setForm={setForm}
          selectedRow={selectedRow}
          error={error}
          editType={() => {}}
          setError={setError}
          header="Edit Block Details"
          uploadedImages={uploadedImages}
          setUploadedImages={setUploadedImages}
          affectedBookings={() => {}}
          blockedVehciles={blockedVehciles}
          setBlockedVehicles={setBlockedVehicles}
        />
      ) : (
        <Viewblockdetails
          selectedRow={selectedRow}
          setActiveTabIndex={setActiveTabIndex}
        />
      )}
    </>
  );
};

export default Blockedvehicles;
